import { MagnifyingGlassIcon, SpinnerGapIcon } from '@phosphor-icons/react';
import { Input } from 'antd';
import { useAppDispatch, useAppSelector } from '../../../../store/store';
import {
  selectPromptTemplateFilters,
  addPromptTemplateFilter,
} from '../../../../store/stylist/slice';
import { useState } from 'react';
import { useSearchPromptTemplatesInfiniteQuery } from '../../../../store/stylist/stylistApi';

const Search = () => {
  const dispatch = useAppDispatch();
  const [value, setValue] = useState('');

  const activeFilters = useAppSelector(selectPromptTemplateFilters);

  const { isFetching } = useSearchPromptTemplatesInfiniteQuery({
    filters: activeFilters,
  });

  const handleSearch = () => {
    if (value.trim()) {
      dispatch(
        addPromptTemplateFilter({
          field: 'search',
          filterType: 'QUERY',
          value: value.trim(),
        }),
      );
    }
  };

  return (
    <Input
      placeholder="Search prompt templates..."
      suffix={
        isFetching ? (
          <SpinnerGapIcon className="anticon-spin" style={{ color: '#bfbfbf' }} />
        ) : (
          <MagnifyingGlassIcon style={{ color: '#bfbfbf' }} />
        )
      }
      allowClear
      value={value}
      onChange={e => setValue(e.target.value)}
      onPressEnter={handleSearch}
      style={{
        maxWidth: 320,
        borderRadius: 20,
      }}
    />
  );
};

export default Search;
